import React from "react";
import SectionLayout from "./SectionLayout";
import { Accordion } from "../ui/accordion";

const Section = ({ sections, dashboardId }) => {
  return (
    <div className="mt-4 px-8">
      <Accordion type="multiple" className="w-full flex flex-col gap-2">
        {sections.map((section, index) => {
          return (
            <SectionLayout
              key={section.label}
              section={section}
              sectionId={index}
              dashboardId={dashboardId}
            />
          );
        })}
      </Accordion>
    </div>
  );
};

export default Section;
